import styled from 'styled-components';

// Container
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Card header with icon (matching DatesTimesTab)
export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const CardIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.08)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fa4616;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const CardTitleGroup = styled.div``;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0;
`;

export const CardSubtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  margin: 4px 0 0 0;
`;

// Section styling (for subsections within cards)
export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => (theme.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) =>
    theme?.colors?.textGray?.secondary ||
    (theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: -8px 0 24px 0;
`;

// Form row - flexible layout
export const FormRow = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || '1fr 1fr'};
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Single field wrapper
export const FieldWrapper = styled.div`
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '20px')};
`;

// Loading state
export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${({ theme }) => (theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 16px;
`;

// Icon wrapper
export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ theme }) =>
    theme?.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.08)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fa4616;

  svg {
    width: 20px;
    height: 20px;
  }
`;
